import lazy from '../../utils/lazy';
import { FuelPumpInfoPage } from '../../constants/url';

const fuelPumpInfoRoutes: RouteInfo[] = [
  {
    path: FuelPumpInfoPage.Home,
    exact: true,
    component: lazy(() => import('./pages/FuelPumpInfo'))
  },
  {
    path: FuelPumpInfoPage.Electric,
    exact: true,
    component: lazy(() => import('./pages/ElectricFuelPump'))
  },
  {
    path: FuelPumpInfoPage.Mechanical,
    exact: true,
    component: lazy(() => import('./pages/MechanicalFuelPumps'))
  },
  {
    path: FuelPumpInfoPage.DirectInjection,
    exact: true,
    component: lazy(() => import('./pages/DirectInjectionFuelPumps'))
  },
  {
    path: FuelPumpInfoPage.SuperDuty,
    exact: true,
    component: lazy(() => import('./pages/SuperDutyFuelPumps'))
  },
  {
    path: FuelPumpInfoPage.HighPerformance,
    exact: true,
    component: lazy(() => import('./pages/HighPerformanceFuelPumps'))
  },
  {
    path: FuelPumpInfoPage.UniversalAutomotive,
    exact: true,
    component: lazy(() => import('./pages/UniversalAutomotiveFuelPumps'))
  },
  {
    path: FuelPumpInfoPage.Downloads,
    exact: true,
    component: lazy(() => import('./pages/Downloads'))
  },
  {
    path: FuelPumpInfoPage.UniversalTransfer,
    exact: true,
    component: lazy(() => import('./pages/UniversalFuelTransferPumps'))
  }
];

export default fuelPumpInfoRoutes;
